import Route from 'cio/routes/base';

export default class ImportingRoute extends Route {}
